import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgxDateRangeInfo } from 'src/app/models/report/date-range-picker-ngx-info';
import * as moment from 'moment';

import { ReportCalendarService } from 'src/app/services/data-services/report-calendar.service';
import { StoreService } from 'src/app/services/store.service';
import { Moment } from 'moment';

// interface DateRange {
//   [key: string]: [moment.Moment, moment.Moment];
// }

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
  @Output() dateChanges = new EventEmitter<any>();
  @ViewChild('datePickerInput', { static: false }) datePickerInput: ElementRef; 
  selected: NgxDateRangeInfo;

  locale: any = {
    format: 'DD/MM/YYYY',
    displayFormat: 'DD/MM/YYYY',
    separator: ' To ',
    cancelLabel: 'Cancel',
    applyLabel: 'Select',
    customRangeLabel: 'Custom range',
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    firstDay: 0
  };
  @Output('dateChange') dateChangeEvent = new EventEmitter();

  inputValue: string = '';

  constructor(
    private calendar: ReportCalendarService,
    private store: StoreService
  ) { }

  ngOnInit(): void {
    this.setInitialDate();

  }

  setInitialDate(): void {
    const todayStart = moment().startOf('day');
    const todayEnd = moment().endOf('day');
    this.selected = {
      startDate: todayStart,
      endDate: todayEnd
    };
    setTimeout(() => {
      const todayEvent = {
        startDate: todayStart,
        endDate: todayEnd
      };

      this.dateChange(todayEvent);
    }, 0);
  }

  ranges = {
    Today: [moment().startOf('day'), moment().endOf('day')],
    Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Till Date': [moment().subtract(10, 'years').startOf('day'), moment().endOf('day')],
    'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
};

getLabelForRange(selectedRange: NgxDateRangeInfo): string {
  const predefinedRanges = {
    'Today': [moment().startOf('day'), moment().endOf('day')],
    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Till Date': [moment().subtract(10, 'years').startOf('day'), moment().endOf('day')]
  };
  const { startDate, endDate } = selectedRange;
  const normalizedSelectedStart = moment(startDate).startOf('day');
  const normalizedSelectedEnd = moment(endDate).endOf('day');
  for (const [label, [predefinedStart, predefinedEnd]] of Object.entries(predefinedRanges)) {
    const normalizedPredefinedStart = moment(predefinedStart).startOf('day');
    const normalizedPredefinedEnd = moment(predefinedEnd).endOf('day');
    if (
      normalizedSelectedStart.isSame(normalizedPredefinedStart, 'day') &&
      normalizedSelectedEnd.isSame(normalizedPredefinedEnd, 'day')
    ) {
      return label;
    }
  }
  const startOfMonth = moment().startOf('month').startOf('day');
  const endOfMonth = moment().endOf('month').endOf('day');
  
  // Check if the selected date range fully covers the current month
  if (
    normalizedSelectedStart.isBefore(endOfMonth) &&
    normalizedSelectedEnd.isAfter(startOfMonth) &&
    (normalizedSelectedStart.isBefore(startOfMonth) || normalizedSelectedEnd.isAfter(endOfMonth))
  ) {
    return 'This Month';
  } else {
    return null;
  }
}


checkIfRangeIsInRange(rangeStart: Moment, rangeEnd: Moment, checkStart: Moment, checkEnd: Moment): boolean {
  // Check if there is any overlap
  const isInRange = 
    (checkStart.isBefore(rangeEnd) || checkStart.isSame(rangeEnd)) &&
    (checkEnd.isAfter(rangeStart) || checkEnd.isSame(rangeStart));
  
  console.log(`Checking if range [${rangeStart.toISOString()} - ${rangeEnd.toISOString()}] overlaps with [${checkStart.toISOString()} - ${checkEnd.toISOString()}]: ${isInRange}`);
  
  return isInRange;
}













  dateChange(ev: NgxDateRangeInfo): void {
    if (ev.startDate && ev.endDate) {
      const startDate = moment(ev.startDate).startOf('day');
      const endDate = moment(ev.endDate).endOf('day');
      const originalRange = {
        startDate: startDate,
        endDate: endDate
      };
      const startDateUTC = startDate.clone().utc();
      const endDateUTC = endDate.clone().utc();
      const normalizedRange = {
        startDate: startDateUTC,
        endDate: endDateUTC
      };
      const label = this.getLabelForRange(normalizedRange);
      if (label) {
        this.inputValue = label;
      } else {
        this.inputValue = `${startDate.format(this.locale.format)} ${this.locale.separator} ${endDate.format(this.locale.format)}`;
      }
      this.calendar.setDate(originalRange);
      this.store.datepickerPreselectedDate = originalRange;
      this.dateChangeEvent.emit(originalRange);
    }
  }

  isInvalidDate(date: any): boolean {
    return date.isAfter(moment());
  }


  clear() {
    if (this.datePickerInput) {
      this.datePickerInput.nativeElement.value = ''; // Clear the input field
    }
    this.selected = null; // Reset the selected date
    this.dateChanges.emit(null); // Notify parent
  }

}
